export default "__VITE_ASSET__33c37030__"